module.exports = __webpack_public_path__ + "img/usoft_weixin_qr.61819a03.png";